export default {
  button: {
    margin: '0 0 -20px'
  },
  pending: {
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      left: '0',
      top: '0',
      width: '100%',
      height: '100%',
      zIndex: '100',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      animation: '0.3s fadeIn'
    }
  },
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 }
  }
}
